import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { Fragment } from "react";
import { Can } from "@/components/citadel/can";
import { AddArticleGroupModal } from "@/modals/stock/add-article-group-modal";

export function ArticleGroupsMenu() {
	const { refetch } = useDataTableContext();

	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<Can
				action="create"
				subject="Stock"
			>
				<Button
					variant="primary"
					icon={<Icon name="Plus" />}
					onClick={disclosure.onOpen}
				>
					{t("stock.add_article_group")}
				</Button>
			</Can>
			{disclosure.isOpen && (
				<AddArticleGroupModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					onComplete={refetch}
				/>
			)}
		</Fragment>
	);
}
